import React from 'react'
// import { Navigate } from 'react-router-dom'
import BackgroundSlider from 'react-background-slider'
import PropTypes from 'prop-types'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Hidden from '@mui/material/Hidden'

import makeStyles from '@mui/styles/makeStyles'

// import { AuthContext } from '../../security/Auth'
// import useSecurity from '../hooks/useSecurity'

import bgFormLogin from '../../assets/img/backgrounds/bg-form-login.svg'
import vectCarouselLogin from '../../assets/img/vectors/vect-carousel-login.svg'

import bgLogin from '../../assets/img/backgrounds/bg-login.webp'
import bgLogin2 from '../../assets/img/backgrounds/bg-login2.webp'
import bgLogin3 from '../../assets/img/backgrounds/bg-login3.webp'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    '& > .fa': {
      margin: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      height: 'auto',
    },
  },
  bgContainer: {
    '& #ReactBackgroundSlider': {
      height: '100%',
      '& figure': {
        top: 'auto',
        left: 'auto',
        width: '50%',
        backgroundSize: 'cover',
        backgroundPositionY: 'top',
        backgroundPositionX: 'center',
        '@media (max-width: 599px)': {
          width: '100%',
          height: '255px',
          backgroundPositionX: 'unset',
        },
      },
    },
  },
  formContainer: {
    width: 'auto',
    height: 'auto',
    display: 'flex',
    maxWidth: '26em',
    color: '#6E7191',
    minHeight: '50em',
    flexDirection: 'column',
    padding: theme.spacing(2),
    '@media (max-width: 599px)': {
      minHeight: '30em',
    },
  },
  formCenterContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(1),
    backgroundImage: `url(${bgFormLogin})`,
    backgroundSize: '85%',
    backgroundPositionX: 'left',
    backgroundRepeat: 'no-repeat',
    backgroundPositionY: 'bottom',
    '@media (max-width: 1199px)': {
      backgroundSize: '100%',
    },
    '@media (max-width: 499px)': {
      background: 'none',
    },
  },
  onda: {
    right: 0,
    bottom: 0,
    width: '28vw',
    position: 'absolute',
  },
}))

const Login = ({ children /* , signoutUser */ }) => {
  const classes = useStyles()
  // const { user } = useContext(AuthContext)
  // const { signout } = useSecurity()

  // if (user) {
  //   if (signoutUser) {
  //     setTimeout(() => signout())
  //   } else {
  //     return <Navigate to="/" />
  //   }
  // }

  return (
    <Grid container className={classes.root}>
      <Grid item sm={6} className={classes.formCenterContainer}>
        <Box className={classes.formContainer}>
          {children}
        </Box>
      </Grid>
      <Grid item className={classes.bgContainer} sm={6}>
        <BackgroundSlider
          images={[bgLogin2, bgLogin3, bgLogin]}
          duration={3}
          transition={1}
        />
        <Hidden smDown>
          <img
            className={classes.onda}
            src={vectCarouselLogin}
            alt="Vetor em formato de onda azul"
          />
        </Hidden>
      </Grid>
    </Grid>
  )
}

Login.propTypes = {
  // signoutUser: PropTypes.bool,
  children: PropTypes.element.isRequired,
}

// Login.defaultProps = {
//   signoutUser: false,
// }

export default Login
